import { setPageNumber } from './page-number';
import { report } from './reporter';
import type { WixBi } from './types';

export const init = () => {
  const wixBi: WixBi = {
    report,
  };

  Object.defineProperty(window, 'wixBi', {
    value: Object.freeze(wixBi),
    writable: false,
    configurable: false,
    enumerable: true,
  });

  window.addEventListener('wix:bi:navigation', (e: any) => {
    setPageNumber(e.detail.pageNumber);
  });
};
